var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWegrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 943,
    height: 825,
    viewBox: "0 0 942.64 824.74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wTeal",
    gradientUnits: "userSpaceOnUse",
    x1: 291.92,
    y1: 122.03,
    x2: 680.82,
    y2: 279.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B0F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6DD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21C3C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wBlue",
    gradientUnits: "userSpaceOnUse",
    x1: 162.12,
    y1: 306.23,
    x2: 660.52,
    y2: 765.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5EA5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#487ADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#293DA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050077"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wTeal)",
    d: "M236.03 235.29L459.3 12.02A17 17 0 0 1 483.34 12.02L706.61 235.29L600.97 340.93A17 17 0 0 1 576.93 340.93L471.32 235.32L365.71 340.93A17 17 0 0 1 341.67 340.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wBlue)",
    d: "M117.66 353.85L12.02 459.49A17 17 0 0 0 12.02 483.53L341.21 812.72A17 17 0 0 0 365.25 812.72L471.32 706.64L577.39 812.72A17 17 0 0 0 601.43 812.72L930.62 483.53A17 17 0 0 0 930.62 459.49L824.98 353.85L589.41 589.42L471.32 471.32L353.23 589.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWegrow);
export default __webpack_public_path__ + "static/media/wegrow.83df2597827d6b08a3cbb31f93cfe83e.svg";
export { ForwardRef as ReactComponent };